import newColors from "@/styles/newColors"
import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles(({
	boxContainer: {
		maxWidth: "200px",
		overflow: "hidden",
		whiteSpace: "nowrap",
		textOverflow: "ellipsis"
	},
	trackableTitleLink: {
		color: newColors.blue[700],
		textDecoration: "none",
		"&:hover": {
			textDecoration: "underline"
		}
	}
}))

export default useStyles
